module.exports = __webpack_public_path__ + "img/03.13027835.png";